module.exports = __webpack_public_path__ + "assets/RestaurantMarker-old-9aefa6.svg";